import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PartService from "../../Controller/PartController"
import PartFinancialService from "../../../Setup/controller/PartFinancialController/PartFinancialController"
import TaxCodeService from "../../../Setup/controller/TaxCodesController/TaxCodeController"
import { handleChange, handleSubmit } from "../../Controller/UpdateFinancialController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";

function PartFinancials({ StockID }) {
    StockID = localStorage.getItem('StockID');
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({
        snt_SalesNominalCode: '0', snt_PurchaseNominalCode: '0', dec_TaxCode: "0",
        vc_CommodityCode: ''
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [TaxCodeList, setTaxCodeData] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const PartID = StockID;
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const fetchTaxCodeList = async () => {
        try {
            const listOfTaxCodes = await TaxCodeService.GetAllTaxCodes();
            setTaxCodeData(listOfTaxCodes);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchPartFinancals = async () => {
        try {

            const data = await PartService.GetPartByID(redirectCallback, PartID);
            const PartFinancial = await PartFinancialService.GetAllPartFinancial(redirectCallback);

            if (data.length > 0) {
                setFormData({
                    ...formData,
                    snt_PurchaseNominalCode: data[0].snt_PurchaseNominalCode ?? PartFinancial[0].PurchaseNominal,
                    snt_SalesNominalCode: data[0].snt_SalesNominalCode ?? PartFinancial[0].SaleNominal,
                    vc_CommodityCode: data[0].vc_CommodityCode,
                    dec_TaxCode: data[0].dec_TaxCode,

                });
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {

        resetForm();
        fetchTaxCodeList();
        if (PartID > 0) {

            fetchPartFinancals();
        }
        else {
            setFormData({
                snt_SalesNominalCode: '0', snt_PurchaseNominalCode: '0', dec_TaxCode: "0",
                vc_CommodityCode: ''
            });

        }
    }, [PartID]);
    const resetForm = () => {

        setFormData({
            snt_SalesNominalCode: '0', snt_PurchaseNominalCode: '0', dec_TaxCode: "0",
            vc_CommodityCode: ''
        });
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);

        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };

        // Validate dec_Quantity field to allow only decimal values
        if (name === 'snt_SalesNominalCode') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.snt_SalesNominalCode = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.snt_SalesNominalCode = formData.snt_SalesNominalCode || '';
            }
        }
        if (name === 'snt_PurchaseNominalCode') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.snt_PurchaseNominalCode = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.snt_PurchaseNominalCode = formData.snt_PurchaseNominalCode || '';
            }
        }
        setFormData(updatedFormData);
    };
    const handleFormSubmit = async (event) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.PK_Stock_ID = PartID;
        debugger;
        const message = await handleSubmit(event, formData, setFormData, setErrors);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        window.scrollTo(0, 0);
        fetchTaxCodeList();
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>


                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>

                            <td style={{width:"13%"}}> <label htmlFor="snt_PurchaseNominalCode" style={{ float: "right" }}>Purchase Nominal &nbsp;&nbsp;</label></td>
                            <td style={{width:"37%"}}>
                                <input type="text" className="form-control" name="snt_PurchaseNominalCode" value={formData.snt_PurchaseNominalCode} onChange={handleFieldChange} />
                                {errors.snt_PurchaseNominalCode && <div style={{ color: 'red' }}>{errors.snt_PurchaseNominalCode}</div>}
                            </td>
                            <td style={{width:"13%"}}>
                                <label htmlFor="snt_SalesNominalCode" style={{ float: "right" }}>Sale Nominal &nbsp;&nbsp;</label>
                            </td>
                            <td style={{width:"37%"}}>
                                <input type="text" className="form-control" name="snt_SalesNominalCode" value={formData.snt_SalesNominalCode} onChange={handleFieldChange} />
                                {errors.snt_SalesNominalCode && <div style={{ color: 'red' }}>{errors.snt_SalesNominalCode}</div>}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="vc_CommodityCode" style={{ float: "right" }}>Commodity Code &nbsp;&nbsp;</label>
                            </td>
                            <td>
                                <input type="text" className="form-control" name="vc_CommodityCode" value={formData.vc_CommodityCode} onChange={handleFieldChange} />
                                {errors.vc_CommodityCode && <div style={{ color: 'red' }}>{errors.vc_CommodityCode}</div>}
                            </td>
                            <td>
                                <label htmlFor="dec_TaxCode" style={{ float: "right" }}>Tax Code &nbsp;&nbsp;</label>
                            </td>
                            <td>
                                <select name="dec_TaxCode" className='form-control' value={formData.dec_TaxCode} onChange={handleFieldChange}>
                                    <option value="0">Select Tax Code</option>
                                    {TaxCodeList.map((tax) => (
                                        <option key={tax.ID} value={tax.ID}>
                                            {tax.vc_Code}
                                        </option>
                                    ))}
                                </select>
                                {errors.dec_TaxCode && <div style={{ color: 'red' }}>{errors.dec_TaxCode}</div>}
                            </td>
                        </tr>
                        <tr>

                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{float:"right"}}>

                                <button style={{ "marginLeft": "10px" }} type="submit" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                   <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    );
}
export default PartFinancials;